import { render } from "./NovaEscala.vue?vue&type=template&id=f7e25766"
import script from "./NovaEscala.vue?vue&type=script&lang=js"
export * from "./NovaEscala.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bhfagundes/Desktop/mobs2/operacoes-front-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__